(function () {
  const TAB_SELECTOR = "[data-naehrwerte-tab]";
  const PANEL_SELECTOR = "[data-naehrwerte-panel]";

  function handleTabClick(event) {
    const button = event.currentTarget;
    const tabValue = button.getAttribute("data-naehrwerte-tab");
    const tableId = button.getAttribute("data-naehrwerte-target");
    const table = document.querySelector(
      `[data-naehrwerte-table="${tableId}"]`,
    );

    if (!table) return;

    const tabs = table.querySelectorAll(TAB_SELECTOR);
    const panels = table.querySelectorAll(PANEL_SELECTOR);

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute("data-naehrwerte-tab") === tabValue;
      tab.setAttribute("aria-pressed", isActive ? "true" : "false");
      tab.classList.toggle("text-primary", isActive);
      tab.classList.toggle("text-subdued", !isActive);
    });

    panels.forEach((panel) => {
      const isActive = panel.getAttribute("data-naehrwerte-panel") === tabValue;
      panel.classList.toggle("hidden", !isActive);
    });
  }

  function init() {
    document.querySelectorAll(TAB_SELECTOR).forEach((tab) => {
      tab.addEventListener("click", handleTabClick);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
